import { LLMBlock } from 'components/IdentifierName/LLMCategorizer/PrompSectionCard';
import { v4 } from 'uuid';

export const promptKindMap: Record<string, string> = {
  rerank: 'Rerank',
  entity: 'Entity',
  message: 'Message',
};

export const promptSourceMap: Record<string, string> = {
  sentences: 'Sentence',
  full: 'Full',
  numbered_sentences: 'Numbered Sentences',
};

export const kindOptions = [
  {
    value: 'rerank',
    label: 'Rerank',
    text: '',
  },
  {
    value: 'entity',
    label: 'Entity',
    text: '',
  },
  {
    value: 'message',
    label: 'Message',
    text: '',
  },
];

export const usageOptions = [
  {
    value: 'true',
    label: 'In Use',
    text: '',
  },
  {
    value: 'false',
    label: 'Not in Use',
    text: '',
  },
];

export const deploymentOptions = [
  {
    value: 'gpt-35-turbo-0125',
    label: 'gpt-35-turbo-0125',
    text: '',
  },
  {
    value: 'Mistral-large-iaxog',
    label: 'Mistral-large-iaxog',
    text: '',
  },
  {
    value: 'gpt4-turbo',
    label: 'gpt4-turbo',
    text: '',
  },
  {
    value: 'gpt4o',
    label: 'gpt4o',
    text: '',
  },
  {
    value: 'gpt4o-mini',
    label: 'gpt4o-mini',
    text: '',
  },
  {
    value: 'gpt5',
    label: 'gpt5',
    text: '',
  },
  {
    value: 'gpt5-mini',
    label: 'gpt5-mini',
    text: '',
  },
  {
    value: 'gpt5-nano',
    label: 'gpt5-nano',
    text: '',
  },
];

export const sourceOptions = [
  {
    value: 'sentences',
    label: 'Sentences',
    text: '',
    disabled: true,
  },
  {
    value: 'full',
    label: 'Full',
    text: '',
    disabled: true,
  },
  {
    value: 'numbered_sentences',
    label: 'Numbered Sentences',
    text: '',
  },
];

export const promptBlockTypeOptions = [
  // { label: 'Main', value: 'main' },
  // { label: 'Secondary', value: 'secondary' },
  { label: 'Main', value: 'text' },
  { label: 'Secondary', value: 'secondary' },
  { label: 'Categories', value: 'categories' },
];

export const getDefaultPromptBlocks = (): LLMBlock[] => {
  const coreRiskId = v4();

  const defaultBlocks: LLMBlock[] = [
    {
      id: v4(),
      name: 'Use Case',
      type: 'text',
      pattern: '',
    },
    {
      id: coreRiskId,
      name: 'Core Risk Model',
      type: 'text',
      pattern: '',
    },
    {
      id: v4(),
      name: 'Supplemental Model',
      type: 'text',
      pattern: '',
      parent: coreRiskId,
    },
    {
      id: v4(),
      name: 'Scoring Guidelines',
      type: 'text',
      pattern: '',
    },
    {
      id: v4(),
      name: 'Scoring Calibration Guide',
      type: 'text',
      pattern: '',
    },
  ];

  return defaultBlocks;
};
